import { useState } from 'react';
import css from './selected-materials.module.scss';
import classNames from 'classnames';
import Services from '../services/services';
import GeneralContacts from '../contacts/general-contacts';
import KBGeneral from '../kb/kb-general';

export enum Tabs {
  MILITARY,
  FAMILY
}

export const tabOptions = [
  {
    id: Tabs.MILITARY,
    name: 'Військовослужбовцям'
  },
  {
    id: Tabs.FAMILY,
    name: 'Родинам'
  }
];

export default function SelectedMaterials() {
  const [selectedTab, setSelectedTab] = useState(tabOptions[0]);

  return (
    <div className={css.selectedMaterials}>
      <div className={css.tabs}>
        {tabOptions.map((t) => {
          return (
            <div
              key={t.id}
              className={classNames(css.tab, { [css.active]: t.id === selectedTab.id })}
              onClick={() => setSelectedTab(t)}>
              {t.name}
            </div>
          );
        })}
      </div>
      <div className={css.content}>
        <Services type={selectedTab.id} />
        <KBGeneral type={selectedTab.id} />
        <GeneralContacts type={selectedTab.id} />
      </div>
    </div>
  );
}
